import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const bugsnagClient = bugsnag({
  apiKey: process.env.VUE_APP_BUGNAG_KEY,
  notifyReleaseStages: ['production', 'staging'],
  releaseStage: process.env.VUE_APP_ENV,
  appVersion: process.env.VUE_APP_COMMIT_HASH
})

bugsnagClient.use(bugsnagVue, Vue)

let isReloading = false
/**
 * Handles critical errors on routing.
 * Usually happens right after deployment.
 * @param {String | RegExp} match
 * @return {function(...[Error]=)}
 */
const handleCriticalError = (match) => error => {
  if ((error.message || error).match(match) && !isReloading) {
    const result = confirm('Уебсайта бе обновен, страницата трябва да се презареди. Ако веднага след това видите пак това съобщение, рестартирайте браузера си или се свържете с нас.')
    if (result) {
      isReloading = true
      location.reload()
    }
    return false
  }
}
export { bugsnagClient, handleCriticalError }
